import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { Alert } from 'components/common';
import { RadioGroup } from 'components/common/form';

interface Props {
  numberOfUsersInProgress: number;
  numberOfUsersWithCompletion: number;
}

const AchievementCompletionsAddInfo = ({
  numberOfUsersInProgress,
  numberOfUsersWithCompletion
}: Props) => {
  const { messages, theme } = useReduxState();

  if (!numberOfUsersInProgress && !numberOfUsersWithCompletion) return null;

  return (
    <div className="info">
      {numberOfUsersWithCompletion ? (
        <Alert
          text={
            <div>
              <div>
                <RadioGroup
                  field="addExistingUsers"
                  labelStyle={{
                    color: theme.warningLightTextColor,
                    fontSize: '1.5rem'
                  }}
                  options={[
                    {
                      id: 'achievement-users-add-existing-users-yes',
                      label: messages.achievementAddExistingCompletionYes,
                      value: true
                    },
                    {
                      id: 'achievement-users-add-existing-users-no',
                      label: messages.achievementAddExistingCompletionNo,
                      value: false
                    }
                  ]}
                />
              </div>
            </div>
          }
          title={getMessageWithPlaceholders({
            message: messages.achievementAddExistingCompletionInfo,
            placeholders: { numberOfUsers: numberOfUsersWithCompletion }
          })}
          titleStyle={{ fontWeight: 600 }}
          type="warning-light"
        />
      ) : null}

      {numberOfUsersInProgress ? (
        <Alert
          text={getMessageWithPlaceholders({
            message: messages.achievementAddExistingInProgressInfo,
            placeholders: { numberOfUsers: numberOfUsersInProgress }
          })}
          type="warning-light"
        />
      ) : null}

      <style jsx>{`
        .info {
          display: flex;
          flex-direction: column;
          gap: 10px;
          padding: 0px 15px 15px;
          margin-top: -5px;
        }
      `}</style>
    </div>
  );
};

export default AchievementCompletionsAddInfo;
